var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_4025_242222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 4.5C4.66953 4.5 4.25 4.08047 4.25 3.5625V2.4375C4.25 1.91953 4.66953 1.5 5.1875 1.5H6.3125C6.83047 1.5 7.25 1.91953 7.25 2.4375V3.5625C7.25 4.08047 6.83047 4.5 6.3125 4.5H5.1875Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 4.5C9.66953 4.5 9.25 4.08047 9.25 3.5625V2.4375C9.25 1.91953 9.66953 1.5 10.1875 1.5H11.3125C11.8305 1.5 12.25 1.91953 12.25 2.4375V3.5625C12.25 4.08047 11.8305 4.5 11.3125 4.5H10.1875Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 9.5C4.66953 9.5 4.25 9.08047 4.25 8.5625V7.4375C4.25 6.91953 4.66953 6.5 5.1875 6.5H6.3125C6.83047 6.5 7.25 6.91953 7.25 7.4375V8.5625C7.25 9.08047 6.83047 9.5 6.3125 9.5H5.1875Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 9.5C9.66953 9.5 9.25 9.08047 9.25 8.5625V7.4375C9.25 6.91953 9.66953 6.5 10.1875 6.5H11.3125C11.8305 6.5 12.25 6.91953 12.25 7.4375V8.5625C12.25 9.08047 11.8305 9.5 11.3125 9.5H10.1875Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 14.5C4.66953 14.5 4.25 14.0805 4.25 13.5625V12.4375C4.25 11.9195 4.66953 11.5 5.1875 11.5H6.3125C6.83047 11.5 7.25 11.9195 7.25 12.4375V13.5625C7.25 14.0805 6.83047 14.5 6.3125 14.5H5.1875Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 14.5C9.66953 14.5 9.25 14.0805 9.25 13.5625V12.4375C9.25 11.9195 9.66953 11.5 10.1875 11.5H11.3125C11.8305 11.5 12.25 11.9195 12.25 12.4375V13.5625C12.25 14.0805 11.8305 14.5 11.3125 14.5H10.1875Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4025_242222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandle);
export default __webpack_public_path__ + "static/media/drag-handle.bc0d3a198eff74c1509589da96b5c2a6.svg";
export { ForwardRef as ReactComponent };